import { Component } from "@angular/core"
import { MatDialogRef } from "@angular/material"

@Component({
  selector: "app-data-updated-dialog",
  templateUrl: "data-updated-dialog.component.html",
  styles: [`
    .dialog-title {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 20px;
      font-weight: 600;
      color: #1a1a1a;
      margin: 0;
    }

    .title-icon {
      color: #c45c00;
      font-size: 28px;
      width: 28px;
      height: 28px;
    }

    .warning-box {
      display: flex;
      align-items: flex-start;
      gap: 14px;
      background-color: #fffbeb;
      border: 1px solid #f59e0b;
      border-radius: 6px;
      padding: 16px;
      margin: 8px 0;
    }

    .warning-icon {
      color: #c45c00;
      font-size: 28px;
      width: 28px;
      height: 28px;
      flex-shrink: 0;
      margin-top: 2px;
    }

    .warning-text p {
      margin: 0 0 12px;
      font-size: 15px;
      line-height: 1.6;
      color: #2d2d2d;
    }

    .warning-text p:last-child {
      margin-bottom: 0;
    }

    .reload-btn {
      background-color: #c45c00 !important;
      color: #fff !important;
      margin-left: 8px;
    }

    .reload-btn .mat-icon {
      font-size: 18px;
      width: 18px;
      height: 18px;
      vertical-align: middle;
      margin-right: 4px;
    }
  `],
})
export class DataUpdatedDialogComponent {

  constructor(public dialogRef: MatDialogRef<DataUpdatedDialogComponent>) { }

}
